module.exports = __webpack_public_path__ + "static/media/480.bed479d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-duster/light/480.png
// module id = 2012
// module chunks = 2